import { createContext, useContext, useState, useCallback } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = "info", duration = 3000) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  const toast = {
    success: (msg, dur) => addToast(msg, "success", dur),
    error:   (msg, dur) => addToast(msg, "error",   dur),
    info:    (msg, dur) => addToast(msg, "info",    dur),
    warning: (msg, dur) => addToast(msg, "warning", dur),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <ToastContainer toasts={toasts} />
    </ToastContext.Provider>
  );
}

function ToastContainer({ toasts }) {
  if (!toasts.length) return null;
  return (
    <div style={{ position:"fixed", bottom:24, right:24, zIndex:9999,
      display:"flex", flexDirection:"column", gap:10 }}>
      {toasts.map((t) => (
        <div key={t.id} className="animate-slideUp" style={{
          padding:"12px 18px", borderRadius:10, fontSize:14, fontWeight:500,
          maxWidth:340, lineHeight:1.5,
          background: t.type==="success" ? "#166534" :
                      t.type==="error"   ? "#7f1d1d" :
                      t.type==="warning" ? "#78350f" : "#1e1b4b",
          border: `1px solid ${
            t.type==="success" ? "#22c55e44" :
            t.type==="error"   ? "#ef444444" :
            t.type==="warning" ? "#f59e0b44" : "#6366f144"}`,
          color:"#fff",
          boxShadow:"0 8px 24px rgba(0,0,0,0.5)",
        }}>
          {t.type==="success" && "✓ "}
          {t.type==="error"   && "✕ "}
          {t.type==="warning" && "⚠ "}
          {t.message}
        </div>
      ))}
    </div>
  );
}

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used inside ToastProvider");
  return ctx;
};
